// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"501":"e69890ff","551":"4034a69b"}[chunkId] + ".chunk.css";
};